'use strict';

const utils = [
  'config',

  function (config) {
    return {
      getApiUrl: function (path) {
        return ((config.apiBaseUrl || '') + '/' +  (path || '')).replace(/([^:]|^)\/{2,}/g, '$1/');
      },
      getApiUrlV2: function (path) {
        return ((config.apiBaseUrlV2 || '') + '/' +  (path || '')).replace(/([^:]|^)\/{2,}/g, '$1/');
      }
    };
  }
];

export default utils;



// WEBPACK FOOTER //
// ./app/src/services/utils.js